export default "__VITE_ASSET__BttrwnSk__"